<template>
  <!--  eslint-disable -->
  <Dialog :visible="value" :class="prefixCls" :custom-class="prefixCls" v-bind="$attrs" top="16vh" v-on="$listeners"
    :show-close="false" @open="onOpened">
    <!--    <slot name="title">-->
    <div class="title text-18" slot="title">
      <div class="flex items-center">
        <icon-warn v-if="type === 'warning'" />
        <span class="ml-1">{{ title }}</span>
      </div>
      <div class="close cursor-pointer" @click.stop="closeMethod">
        <i class="el-icon-close" />
      </div>
    </div>
    <slot />
  </Dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import iconWarn from '@/assets/svg/icon/iconWarning.svg'
import { useGlobSetting } from '~/hooks/useGlobSetting'

export default {
  name: "BaseDialog",
  components: {
    Dialog,
    iconWarn
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    offset: {
      type: Array,
      default: () => [0, 0, 0, 0]
    }
  },
  data() {
    const { prefixCls } = useGlobSetting()
    return {
      prefixCls: prefixCls + '-dialog'
    }
  },
  methods: {
    closeMethod() {
      this.$emit('change', false)
    },
    onOpened() {
      this.$nextTick(() => {
        if (!this.$el) {
          return;
        }
        const top = this.offset[0] || 0;
        const right = this.offset[1] || 0;
        const bottom = this.offset[2] || 0;
        const left = this.offset[3] || 0;
        const parentDom = this.$el.parentNode;
        if (parentDom) {
          const modelDom = parentDom.lastChild;
          if (modelDom) {
            modelDom.style.top = top + 'px';
            modelDom.style.left = left + 'px';
            modelDom.style.right = right + 'px';
            modelDom.style.bottom = bottom + 'px';
          }
        }
        if (this.$el) {
          const dom = this.$el
          dom.style.top = top + 'px';
          dom.style.left = left + 'px';
          dom.style.right = right + 'px';
          dom.style.bottom = bottom + 'px';
        }
      })

    }
  }
}
</script>

<style lang="less" scoped>
@prefix-cls: ~'@{namespace}-dialog';


.@{prefix-cls} {

  /deep/ .el-dialog {
    background-color: var(--bg-color-overlay);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid var(--border-color-base);
    border-radius: 12px;
    box-shadow: var(--shadow-lg);
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-dialog__header {
    position: relative;
    padding: 24px 24px 0 24px;
    z-index: 10;

    .title {
      position: relative;
      color: var(--text-color);
      font-size: 18px;
      font-weight: 600;

      .flex {
        display: flex;
        align-items: center;
      }

      .close {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 32px;
        height: 32px;
        border-radius: 50%;
        transition: all 0.3s;

        i {
          color: var(--text-secondary);
          font-size: 20px;
          font-weight: bold;
          transition: color 0.3s;
        }

        &:hover {
          background-color: var(--bg-color-hover);

          i {
            color: var(--text-color);
          }
        }
      }
    }

  }

  /deep/.el-dialog__body {
    padding: 24px;
    position: relative;
    z-index: 10;
    color: var(--text-color);
  }
}
</style>
